import { useContext } from 'react'
import { useParams } from 'react-router'
import ClinicHeader from 'src/clinic/components/ClinicHeader'
import { AvailabilityPageContainer } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import ClinicBrandPayoutReports from './ClinicBrandPayoutReports'

export default function BrandPayoutReports() {
  const { chosenRoleFlow, ownerData, assistantData, refreshOwnersAssociatedBrandsData } =
    useContext(ClinicDataContext)
  const { clinicBrandId } = useParams()

  const associatedClinicBrandsData = ownerData?.associatedClinicBrandsData
  const thisClinicBrandData = associatedClinicBrandsData?.find((item) => item?.id === clinicBrandId)

  return (
    <AvailabilityPageContainer>
      <ClinicHeader
        heading={`${
          thisClinicBrandData?.brandName || thisClinicBrandData?.title || ''
        } Payout Reports`}
      />
      <ClinicBrandPayoutReports
        apiUrl="/api/secure/clinic-admin/reports/payout-reports/paginated"
        isForClinicBrand={true} // Ensure this is explicitly set
        associatedClinicBrandsData={associatedClinicBrandsData}
        clinicBrandId={clinicBrandId}
        thisClinicBrandData={thisClinicBrandData}
      />
    </AvailabilityPageContainer>
  )
}
